import { useMyDialog } from "../context/MyDialogProvider";
import PayDialog from "./PayDialog";

interface PayDialogButtonProps {
  currency?: string;
  order_id?: number;
  amount?: number;
  total?: number | string;
  itemId: number | string;
  padding?: string;
  rounded?: string;
  payload?: any;
}

export default function PayDialogButton({
  currency="RF",
  order_id,
  amount,
  itemId,
  padding = "px-5 py-2.5",
  rounded = "xl",
  payload
}: PayDialogButtonProps) {
  const { open } = useMyDialog();

  return (
    <button
      onClick={() => open({ content: <PayDialog itemId={itemId} amount={amount} payload={payload} order_id={order_id} /> })}
      className={`${padding} bg-blue-600 hover:bg-blue-700 text-white rounded-${rounded} font-semibold transition`}
    >
      💳  Pay {currency} {Number(amount) / 100}
    </button>
  );
}